import Button, { ButtonProps } from '@mui/material/Button';

export { Button, ButtonProps };
